/* Flash Global SIM search.
   1. Destination search: the query is matched against assets/fgs-search-destinations.json
      (country names in Indonesian and English, other spellings, cities) with typo tolerance.
      Matching plans are shown in a fixed order: country plan, combos, regional.
      Names, prices and photos come live from the store (/products/<handle>.js).
   2. If no destination matches, it falls back to Shopify's own predictive search.
   Config comes from window.FGSSearchConfig (set in layout/theme.liquid). */
/* Flash destination search: matches a query against every destination's names
   (Indonesian, English, other spellings, cities) with typo tolerance, and returns
   destinations with their products in display order. Same file is used by the theme. */
(function (root) {
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '')
      .replace(/'/g, '').replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  // Damerau-Levenshtein (optimal string alignment), capped for speed
  function dist(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev2 = null, prev = [], cur, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i]; var rowMin = i;
      for (j = 1; j <= b.length; j++) {
        var cost = a[i - 1] === b[j - 1] ? 0 : 1;
        var v = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
        if (prev2 && i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, prev2[j - 2] + 1);
        cur[j] = v; if (v < rowMin) rowMin = v;
      }
      if (rowMin > max) return max + 1;
      prev2 = prev; prev = cur;
    }
    return prev[b.length];
  }
  function scoreAlias(q, a) {
    if (a === q) return 100;
    if (q.length >= 2 && a.indexOf(q) === 0) return 85 - Math.min(10, (a.length - q.length) * 0.2);
    if (q.length >= 3) {
      var words = a.split(' ');
      for (var w = 1; w < words.length; w++) if (words[w].indexOf(q) === 0) return 65;
    }
    if (q.length >= 4) {
      var max = q.length >= 8 ? 2 : 1;
      var d = dist(q, a, max);
      if (d <= max) return 50 - d * 5;
      if (a.length > q.length) { var dp = dist(q, a.slice(0, q.length), max); if (dp <= max && q.length >= 5) return 40 - dp * 5; }
    }
    return 0;
  }
  function search(data, query, limit) {
    var q = norm(query); if (!q) return [];
    var out = [];
    for (var i = 0; i < data.d.length; i++) {
      var d = data.d[i], best = 0, hit = '';
      for (var k = 0; k < d.a.length; k++) {
        var s = scoreAlias(q, d.a[k]);
        if (s > best) { best = s; hit = d.a[k]; if (s === 100) break; }
      }
      if (best) out.push({ dest: d, score: best - (d.r ? 3 : 0), matched: hit });
    }
    out.sort(function (x, y) { return y.score - x.score || (x.dest.r || 0) - (y.dest.r || 0) || x.dest.id.localeCompare(y.dest.id); });
    // when there is a clear match, drop weak typo guesses (e.g. 'selandia' should not also suggest Belanda)
    if (out.length && out[0].score >= 80) out = out.filter(function (x) { return x.score >= 50; });
    return out.slice(0, limit || 6);
  }
  root.FGSDestSearch = { norm: norm, search: search };
})(typeof window !== 'undefined' ? window : this);

(function () {
  'use strict';
  var CFG = window.FGSSearchConfig || {};
  var S = CFG.strings || {};
  var ROOT = (CFG.root || '/').replace(/\/?$/, '/');
  window.Shopify = window.Shopify || {};

  Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '', re = /\{\{\s*(\w+)\s*\}\}/, fmt = (format || this.money_format || '${{amount}}');
    function opt(o, d) { return typeof o == 'undefined' ? d : o; }
    function delim(number, precision, thousands, decimal) {
      precision = opt(precision, 2); thousands = opt(thousands, ','); decimal = opt(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    switch (fmt.match(re)[1]) {
      case 'amount': value = delim(cents, 2); break;
      case 'amount_no_decimals': value = delim(cents, 0); break;
      case 'amount_with_comma_separator': value = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delim(cents, 0, '.', ','); break;
    }
    return fmt.replace(re, value).replace(/^Rp[\s ]+/i, 'Rp');
  };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sized(url, w) { if (!url) return ''; if (url.indexOf('//') === 0) url = 'https:' + url; return url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }

  // destination list: loaded once, on first use
  var dataPromise = null;
  function loadData() {
    if (!dataPromise) dataPromise = CFG.dataUrl ? fetch(CFG.dataUrl).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }) : Promise.resolve(null);
    return dataPromise;
  }
  // live product info, cached per handle (null if the product is not on this store)
  var prodCache = {};
  function loadProduct(h) {
    if (!prodCache[h]) prodCache[h] = fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return prodCache[h];
  }

  var ICON_PLACEHOLDER = '<div class="w-full h-full flex items-center justify-center"><svg class="h-8 w-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg></div>';
  var CHEVRON = '<div class="flex-shrink-0"><svg class="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" /></svg></div>';

  function row(o) {
    var img = o.image ? '<img src="' + esc(o.image) + '" alt="' + esc(o.title) + '" class="w-full h-full object-cover" loading="lazy" />' : ICON_PLACEHOLDER;
    var tag = o.tag != null ? '<span class="fgs-tag fgs-tag--' + o.tag + '">' + esc((S.tags || [])[o.tag] || '') + '</span>' : '';
    var sub = o.sub ? '<p class="fgs-sub text-xs text-paragraph truncate">' + esc(o.sub) + '</p>' : '';
    var price = o.price != null ? '<p class="text-xs text-primary font-bold mt-1"><span class="font-normal text-paragraph">' + esc(S.from || 'from') + '</span> ' + esc(o.price) + '</p>' : '';
    return '<a href="' + esc(o.url) + '" class="flex items-center gap-4 p-4 hover:bg-surface-light transition-colors border-b border-gray-100" data-search-result-item>' +
      '<div class="flex-shrink-0 w-16 h-16 bg-gray-100 rounded-lg overflow-hidden">' + img + '</div>' +
      '<div class="flex-1 min-w-0"><div class="fgs-title"><h3 class="text-sm font-heading font-bold truncate">' + esc(o.title) + '</h3>' + tag + '</div>' + sub + price + '</div>' +
      CHEVRON + '</a>';
  }

  function PredictiveSearch(component) {
    var self = this;
    this.component = component;
    this.form = component.querySelector('form');
    this.input = component.querySelector('[data-search-input]');
    this.dropdown = component.querySelector('[data-search-dropdown]');
    this.resultsContainer = component.querySelector('[data-search-results]');
    this.loadingState = component.querySelector('[data-search-loading]');
    this.emptyState = component.querySelector('[data-search-empty]');
    if (!this.input || !this.dropdown || !this.form) return;
    this.debounceTimer = null; this.currentRequest = null; this.selectedIndex = -1; this.seq = 0;

    this.input.addEventListener('input', function (e) { self.handleInput(e); });
    this.input.addEventListener('focus', function (e) { loadData(); self.handleFocus(e); });
    this.input.addEventListener('keydown', function (e) { self.handleKeydown(e); });
    document.addEventListener('click', function (e) { if (!component.contains(e.target)) self.closeDropdown(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.closeDropdown(); });
    window.addEventListener('scroll', function () { if (!self.dropdown.classList.contains('hidden')) self.repositionDropdown(); }, { passive: true });
    window.addEventListener('resize', function () { if (!self.dropdown.classList.contains('hidden')) self.repositionDropdown(); });
  }

  PredictiveSearch.prototype.repositionDropdown = function () {
    var rect = this.component.getBoundingClientRect(), formRect = this.form.getBoundingClientRect();
    this.dropdown.style.top = (formRect.bottom + 8) + 'px';
    this.dropdown.style.left = rect.left + 'px';
    this.dropdown.style.width = rect.width + 'px';
    this.dropdown.style.right = 'auto';
  };

  PredictiveSearch.prototype.handleInput = function (e) {
    var self = this, query = e.target.value.trim();
    clearTimeout(this.debounceTimer);
    if (this.currentRequest) this.currentRequest.abort();
    if (query.length < 2) { this.seq++; this.closeDropdown(); return; }
    this.showLoading();
    this.debounceTimer = setTimeout(function () { self.performSearch(query); }, 200);
  };

  PredictiveSearch.prototype.handleFocus = function (e) {
    if (e.target.value.trim().length >= 2 && this.resultsContainer.children.length > 0) this.openDropdown();
  };

  PredictiveSearch.prototype.handleKeydown = function (e) {
    if (this.dropdown.classList.contains('hidden')) return;
    var items = this.resultsContainer.querySelectorAll('[data-search-result-item]');
    if (e.key === 'ArrowDown') { e.preventDefault(); this.selectedIndex = Math.min(this.selectedIndex + 1, items.length - 1); this.updateSelection(items); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); this.selectedIndex = Math.max(this.selectedIndex - 1, -1); this.updateSelection(items); }
    else if (e.key === 'Enter') {
      // Enter with nothing highlighted opens the first plan when the query matched a destination
      var target = items[this.selectedIndex >= 0 ? this.selectedIndex : 0];
      if (target && (this.selectedIndex >= 0 || this.lastWasDestination)) { e.preventDefault(); target.click(); }
    }
  };

  PredictiveSearch.prototype.updateSelection = function (items) {
    var idx = this.selectedIndex;
    items.forEach(function (item, i) { item.classList.toggle('bg-surface-light', i === idx); });
    if (idx >= 0 && items[idx]) items[idx].scrollIntoView({ block: 'nearest' });
  };

  PredictiveSearch.prototype.performSearch = function (query) {
    var self = this, seq = ++this.seq;
    loadData().then(function (data) {
      if (seq !== self.seq) return;
      var matches = data && window.FGSDestSearch ? window.FGSDestSearch.search(data, query, 4) : [];
      if (!matches.length) return self.suggestSearch(query, seq);
      // plans of the best destination first, then the next destinations, max 6, no repeats
      var handles = [], seen = {};
      matches.forEach(function (m) { m.dest.p.forEach(function (h) { if (!seen[h] && handles.length < 6) { seen[h] = 1; handles.push(h); } }); });
      Promise.all(handles.map(loadProduct)).then(function (prods) {
        if (seq !== self.seq) return;
        var bonus = {}; (data.b || []).forEach(function (h) { bonus[h] = 1; });
        var rows = [];
        prods.forEach(function (p, i) {
          if (!p) return;                                   // not sold on this store: skip
          var h = handles[i], k = data.k ? data.k[h] : null;
          rows.push(row({
            url: ROOT + 'products/' + h, title: p.title, image: sized(p.featured_image, 160),
            price: Shopify.formatMoney(p.price_min != null ? p.price_min : p.price, Shopify.money_format),
            tag: k == null ? null : k, sub: bonus[h] ? S.bonus : ''
          }));
        });
        if (!rows.length) return self.suggestSearch(query, seq);
        self.lastWasDestination = true;
        self.show(rows.join(''), query);
      });
    });
  };

  // Shopify predictive search, used when the query is not a destination
  PredictiveSearch.prototype.suggestSearch = function (query, seq) {
    var self = this, controller = new AbortController();
    this.currentRequest = controller;
    this.lastWasDestination = false;
    var params = new URLSearchParams({ q: query, 'resources[type]': 'product,collection', 'resources[options][product][limit]': '6', 'resources[options][collection][limit]': '3' });
    fetch(ROOT + 'search/suggest.json?' + params.toString(), { signal: controller.signal })
      .then(function (r) { if (!r.ok) throw new Error('Search failed'); return r.json(); })
      .then(function (data) {
        if (seq !== self.seq) return;
        var res = (data.resources && data.resources.results) || {};
        var html = (res.collections || []).map(function (c) {
          return row({ url: c.url, title: c.title, image: c.image || '', sub: S.collection });
        }).join('') + (res.products || []).map(function (p) {
          return row({ url: p.url, title: p.title, image: p.image || '', price: Shopify.formatMoney(p.price_min || p.price, Shopify.money_format) });
        }).join('');
        if (!html) return self.showEmptyState();
        self.show(html, query);
      })
      .catch(function (err) { if (err.name !== 'AbortError') { console.error('Search error:', err); self.closeDropdown(); } });
  };

  PredictiveSearch.prototype.show = function (html, query) {
    this.hideLoading(); this.emptyState.classList.add('hidden'); this.selectedIndex = -1;
    this.resultsContainer.innerHTML = html;
    var all = document.createElement('a');
    all.href = ROOT + 'search?q=' + encodeURIComponent(query);
    all.className = 'block p-4 text-center text-sm font-medium text-primary hover:bg-surface-light transition-colors border-t-2 border-gray-200';
    all.textContent = (S.viewAll || 'View all results for') + ' "' + query + '"';
    this.resultsContainer.appendChild(all);
    this.openDropdown();
  };
  PredictiveSearch.prototype.showLoading = function () { this.loadingState.classList.remove('hidden'); this.resultsContainer.classList.add('hidden'); this.emptyState.classList.add('hidden'); this.openDropdown(); };
  PredictiveSearch.prototype.hideLoading = function () { this.loadingState.classList.add('hidden'); this.resultsContainer.classList.remove('hidden'); };
  PredictiveSearch.prototype.showEmptyState = function () { this.hideLoading(); this.resultsContainer.innerHTML = ''; this.resultsContainer.classList.add('hidden'); this.emptyState.classList.remove('hidden'); this.openDropdown(); };
  PredictiveSearch.prototype.openDropdown = function () { this.repositionDropdown(); this.dropdown.classList.remove('hidden'); };
  PredictiveSearch.prototype.closeDropdown = function () { this.dropdown.classList.add('hidden'); this.selectedIndex = -1; };

  function init() {
    document.querySelectorAll('[data-search-component]').forEach(function (c) {
      if (!c.__fgsSearch) c.__fgsSearch = new PredictiveSearch(c);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
